import { ArenaGameState } from '../../../state/ArenaTypes';
import {
  GameEventSynthesizer,
  createDeterministicEventId,
  GameEventItem
} from '../../common/events';

/**
 * Spades Game Event Synthesizer.
 * Synthesizes Spades-specific domain events (such as SPADES_BROKEN)
 * by inspecting authoritative state transitions strictly once per hand.
 */
export class SpadesEventSynthesizer extends GameEventSynthesizer {
  public readonly gameType = 'SPADES';
  private prevSpadesBroken = false;

  public override synthesize(
    currentState: ArenaGameState,
    previousState?: ArenaGameState | null
  ): GameEventItem[] {
    const isSpadesBroken = Boolean(currentState?.spadesBroken);
    const wasBroken =
      previousState !== undefined && previousState !== null
        ? Boolean(previousState.spadesBroken)
        : this.prevSpadesBroken;

    const currentHand = currentState?.handNumber ?? 0;
    const shouldTrigger = this.detectOncePerHandTransition(
      'SPADES_BROKEN',
      isSpadesBroken,
      wasBroken,
      currentHand,
      currentState?.phase
    );

    this.prevSpadesBroken = isSpadesBroken;

    if (!shouldTrigger) {
      return [];
    }

    const eventId = createDeterministicEventId(this.gameType, 'SPADES_BROKEN', currentHand);
    const spadesBrokenEvent: GameEventItem = {
      id: eventId,
      type: 'SPADES_BROKEN',
      timestamp: Date.now()
    };

    return [spadesBrokenEvent];
  }

  public override resetHand(handNumber: number): void {
    super.resetHand(handNumber);
    this.prevSpadesBroken = false;
  }

  public override reset(): void {
    super.reset();
    this.prevSpadesBroken = false;
  }
}
